//
import { List as ImmutableList, Map as ImmutableMap, Record } from 'immutable';

export const mkVehiclesStore = Record({
  resourcesById: ImmutableMap(),

  lastSyncDate: undefined,
  loadPending: true,

  isLoading: false,
  pendingAmount: undefined,
});

export const mkOdometerYear = Record({
  year: undefined,
  odometerStart: undefined,
  odometerEnd: undefined,
});

// ////////////////////////////////////////////////////////////////////////////////////////////////
// Vehicle - Base Vehicle Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////

// ================================================================================================
// Save for __________  Properties & Types
// ================================================================================================

export const mkVehicle = Record({
  id: undefined,
  clientId: undefined,
  isDeleted: false,
  modifiedAt: undefined,

  name: undefined,
  make: undefined,
  model: undefined,
  year: undefined,
  isDefault: false,
  annualOdometer: ImmutableList(),
  currentValue: undefined,
  serviceStartOn: undefined,
  iconType: undefined,
});
